export default "__VITE_ASSET__3sa4aExS__"